<template>
  <div>
    <v-row class="mb-3" align="center" justify="center">
      <v-col lg="3" sm="6" cols="12">
        <v-select
          :items="statusFillter"
          :label="$t('Status')"
          v-model="configDatatale.paramsRequest.status"
          :item-text="__attr"
          outlined
          dense
          hide-details
        ></v-select>
      </v-col>
      <v-col lg="4" sm="6" cols="12">
        <v-row>
          <v-col md="6">
            <datepicker
              v-model="configDatatale.paramsRequest.from_date"
              :label="$t('From date')"
            />
          </v-col>
          <v-col md="6">
            <datepicker
              v-model="configDatatale.paramsRequest.to_date"
              :label="$t('To date')"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="3" sm="6" cols="12">
        <v-text-field
          v-model="configDatatale.paramsRequest._search"
          append-icon="mdi-magnify"
          :label="$t('Key word')"
          outlined
          dense
          hide-details
          @keydown.enter="handleSearch($event)"
        />
      </v-col>
      <v-col lg="2" sm="6" cols="12">
        <v-btn color="primary" medium outlined @click="handleSearch($event)">
          {{ $t('Search') }}
        </v-btn>
      </v-col>
    </v-row>
    <datatable ref="myWorkingDatatable" :config="configDatatale" />
  </div>
</template>

<script>
import Datatable from '@/components/Datatable'
import Datepicker from '@/components/Datepicker'
import { get } from 'vuex-pathify'
import { utcToLocal, isOverDueTask } from '@utils'

export default {
  components: {
    Datatable, Datepicker
  },

  data: vm => ({
    configDatatale: {
      url: '/api/tasks/datatable',
      queryBuilder: {
        _include: ['project', 'project.manager']
      },
      operations: [
        {
          color: 'primary',
          text: 'View',
          icon: 'mdi-eye',
          method: function(item) {
            vm.$router.push({
              name: 'my-workings.detail',
              params: { id: item.id }
            })
          }
        }
      ],
      columns: [
        {
          text: 'ID',
          data: 'id',
          name: 'id'
        },
        {
          text: vm.$t('Task name'),
          data: 'name',
          name: 'name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'my-workings.detail', params: {id:${item.id}} }">${item.name}</router-link>`
          }
        },
        {
          text: vm.$t('Project name'),
          data: 'project.name',
          name: 'project.name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'projects.show', params: {id:${item.project.id}} }">${item.project.name}</router-link>`
          }
        },
        {
          text: vm.$t('Start date'),
          data: 'start_date',
          name: 'start_date',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return utcToLocal(item[column], 'DD/MM/YYYY')
          }
        },
        {
          text: vm.$t('Due date'),
          data: 'due_date',
          name: 'due_date',
          html: true,
          render: function(item, column) {
            if (!item || !item.due_date) {
              return null
            }
            const classElement = vm.isOverDueTask(item) ? 'font-weight-bold red--text' : ''
            return `<span class="${classElement}">${utcToLocal(item[column], 'DD/MM/YYYY')}</span>`
          }
        },
        {
          text: vm.$t('Priority'),
          data: 'priority',
          name: 'priority',
          html: true,
          render: function(item, column) {
            if (!item || !item[column]) {
              return null
            }
            return `<span class='color-priority priority-${item[column]}'>${vm.__attr(`priority.${item[column]}`)}</span>`
          }
        },
        {
          text: vm.$t('Weight'),
          data: 'weight',
          name: 'weight'
        },
        {
          text: vm.$t('Status'),
          data: 'status',
          name: 'status',
          html: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<span class='color-status ${item[column]}'>${vm.__attr(item[column])}</span>`
          }
        },
        {
          text: vm.$t('Operations'),
          data: '_operations',
          name: null,
          searchable: false,
          orderable: false,
          search: {
            value: null,
            regex: false
          }
        }
      ],
      setting: {
        displaySearchInput: false,
        operationStyle: 'list'
      },
      paramsRequest: {
        status: '',
        from_date: null,
        to_date: null,
        _search: null
      }
    },
    dialog: false,
    id: null
  }),

  methods: {
    isOverDueTask,

    handleSearch(e) {
      e.preventDefault()
      const filter = {
        ...this.configDatatale.paramsRequest
      }
      this.$refs.myWorkingDatatable.setParamsRequest(filter)
      this.$refs.myWorkingDatatable.fetchData()
      return false
    }
  },

  computed: {
    ...get('common', ['task_status']),
    statusFillter() {
      return [
        {
          text: 'All',
          value: ''
        },
        ...this.task_status
      ]
    }
  }
}
</script>

<style lang="scss">
.task-status {
  border-radius: 3px;
  padding:3px;
  color: white;
}
</style>
